import { useMemo } from "react";
import { RefreshCw } from "lucide-react";
import { SideDrawer } from "@/components/common/SideDrawer/SideDrawer";
import { useSessionDetail } from "@/hooks/brain/useSessionDetail";
import type { ToolInvocation } from "@/types/brain/session";
import { MessageDecisionTrace } from "./MessageDecisionTrace";

interface SessionDetailDrawerProps {
  sessionId: string | null;
  userId: string;
  onClose: () => void;
}

export const SessionDetailDrawer = ({ sessionId, userId, onClose }: SessionDetailDrawerProps) => {
  const { data, isLoading, isError } = useSessionDetail(sessionId, userId);

  const toolInvocationsById = useMemo(() => {
    const map = new Map<string, ToolInvocation>();
    for (const invocation of data?.tool_invocations ?? []) {
      map.set(invocation.id, invocation);
    }
    return map;
  }, [data?.tool_invocations]);

  return (
    <SideDrawer isOpen={!!sessionId} onClose={onClose} width="85vw" title="Session Detail">
      <div className="py-4">
        {isLoading ? (
          <div className="text-center py-12 text-genie-text-secondary">
            <RefreshCw className="h-6 w-6 animate-spin mx-auto mb-2 text-genie-primary" />
            Loading session...
          </div>
        ) : isError || !data ? (
          <div className="text-center py-12 text-genie-text-muted">Failed to load session</div>
        ) : (
          <div className="space-y-3">
            {data.messages.map((message) => (
              <div key={message.id} className={`flex ${message.role === "user" ? "justify-end" : "justify-start"}`}>
                <MessageDecisionTrace message={message} toolInvocationsById={toolInvocationsById} />
              </div>
            ))}
          </div>
        )}
      </div>
    </SideDrawer>
  );
};
